import moment from 'moment-timezone';

export const formatSessionLabelWithTimezone = (
  sessionDateTime: string,
  sessionDurationInMinutes: number,
  tz: string | null,
) => {
  const defaultTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const sessionDateTimeWithoutZ = sessionDateTime.replace('Z', '');
  const start = moment.tz(sessionDateTimeWithoutZ, tz || defaultTz);

  const formattedDate = start.format('MMMM Do');
  const formattedStartTime =
    start.minute() === 0 ? start.format('h A') : start.format('h:mm A');

  const end = start.clone().add(sessionDurationInMinutes, 'minutes');
  const formattedEndTime =
    end.minute() === 0 ? end.format('h A') : end.format('h:mm A');

  return `${formattedDate}, ${formattedStartTime} - ${formattedEndTime}`;
};
